/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AddInventoryRestockDialog.vue?vue&type=template&id=61e87306"
import script from "./AddInventoryRestockDialog.vue?vue&type=script&lang=js"
export * from "./AddInventoryRestockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e87306')) {
      api.createRecord('61e87306', component.options)
    } else {
      api.reload('61e87306', component.options)
    }
    module.hot.accept("./AddInventoryRestockDialog.vue?vue&type=template&id=61e87306", function () {
      api.rerender('61e87306', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/AddInventoryRestockDialog.vue"
export default component.exports